module.exports = __webpack_public_path__ + "img/732603.257df1d6.jpg";